
    var riot = require('riot')
    //src: starling/src/tags/menu/items/menu-item-create-region-from-selection.html
riot.tag2('menu-item-create-region-from-selection',
  '<i class="material-icons floating-menu_icon">format_shapes</i> <span class="floating-menu_label">Create Region from selection</span>',
  '',
  'class="floating-menu_item" onclick="{handleClick}"', function(opts) {
'use strict';

var _this = this;

var _regionUi = require('lib/region-ui');

var _util = require('lib/util');

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var canvas = opts.canvas;

this.handleClick = function (e) {
  var nodes = canvas.getSelectedNodes();
  var regions = canvas.store.getRegions().filter(function (r) {
    return _regionUi.regionUI.getSelectedRegionIds().has(r.id);
  });

  var _canvas$getContentExt = canvas.getContentExtents({ nodes: nodes, regions: regions }),
      et = _canvas$getContentExt[0],
      el = _canvas$getContentExt[1],
      eb = _canvas$getContentExt[2],
      er = _canvas$getContentExt[3];

  var margin = 50;

  var top = et - margin;
  var left = el - margin;
  var bottom = eb + margin;
  var right = er + margin;

  var region = _regionUi.regionUI.createRegion({
    title: nodes[0].title,
    top: top,
    left: left,
    right: right,
    bottom: bottom
  });

  _regionUi.regionUI.selectRegion(region.id);

  _eventTracking2.default.track({
    category: (0, _util.getTrackingLabel)(_this.parent),
    action: 'Create Region From Selection',
    label: 'Create'
  });

  _this.parent.hide();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('menu-item-create-region-from-selection')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/menu/items/menu-item-create-region-from-selection.html
// module id = 705
// module chunks = 0